import React, {useState,useEffect} from 'react'
import './shopingCard.css'

import { motion } from 'framer-motion'
import ProductsAddCard from './prodcutsAddToCard/productsAddCard';
import ViewAllProductsAdd from './viewAllProductsAdd/viewAllProductsAdd';

const ShopingCard = ({shoppingCart, setShoppingCart, remoreProductShoppingCard, handleCantidad, stateViewdDetail, handleStateViewdDetail, TIENDA}) => {

    const [stateModal, setStateModal] = useState(true);

    const showMModal =()=>{

    }

    
    // modal view detail products added
    // const [stateViewdDetail,setStateViewdDetail] = useState(false);

   
    return (
        <div>
            <div className="relative shoping-card-container rounded-b-full">
               <div className="">
                <motion.div whileTap={{scale:0.98}} onClick={()=>handleStateViewdDetail()}  id="card-shopw-home" className="shoping-card  mr-2 bg-green-400  p-3 md:p-2 rounded-full text-gray-100 hover:text-white focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-gray-800 focus:ring-white shadow-2xl">
                        <div className="absolute bg-indigo-700 px-2 rounded-3xl" style={{top:'-12px', left:'0px'}}>{shoppingCart.length}</div>
                        <span className="sr-only">View notifications</span>
                        {/* Heroicon name: bell */}
                        {/* <svg className="h-6 w-6" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9" />
                                </svg> */}
                        <svg className="h-7 w-7" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 3h2l.4 2M7 13h10l4-8H5.4M7 13L5.4 5M7 13l-2.293 2.293c-.63.63-.184 1.707.707 1.707H17m0 0a2 2 0 100 4 2 2 0 000-4zm-8 2a2 2 0 11-4 0 2 2 0 014 0z" />
                        </svg>
                    </motion.div>
               </div>
            </div>

            {/* modal productsAddCard */}
            {
                stateModal?
                <ProductsAddCard shoppingCart={shoppingCart} remoreProductShoppingCard={remoreProductShoppingCard} TIENDA={TIENDA} ></ProductsAddCard>
                :''
            }

            {/* carts products alls */}

            {
                stateViewdDetail?
                    <ViewAllProductsAdd shoppingCart={shoppingCart} remoreProductShoppingCard={remoreProductShoppingCard} handleCantidad={handleCantidad} TIENDA={TIENDA} />
                :''
            }
        </div>

    );
}

export default ShopingCard;